import { Component, OnInit } from '@angular/core';
import { Tasks, TaskListService } from 'src/app/core/http/taskList/task-list.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { SchemaService, answer } from 'src/app/shared/services/schema/schema.service';
import { RunService, Task } from 'src/app/core/http/run/run.service';

@Component({
  selector: 'app-adm-tasks',
  templateUrl: './adm-tasks.component.html',
  styleUrls: ['./adm-tasks.component.css']
})
export class AdmTasksComponent implements OnInit {
  schemaModel = {};
  lesson_id = '-1';
  tasks: Tasks[];
  mySchema=null;
  answerModule="form";
  formFields = [];
  inputWidget='text';
  currentTask="-1";
  currentTaskId = "-1";
  checkAnswer = '';
  query= new FormControl('');
  taskForm: FormGroup;
  responseCheck = null;
  constructor(private taskListService: TaskListService, private runService: RunService, private schemaService: SchemaService, private route: ActivatedRoute,  private _fb: FormBuilder) {
    this.lesson_id = this.route.snapshot.paramMap.get("lesson");
  }

  ngOnInit(): void {
    this.getAll();
    this.taskForm = this._fb.group( {
      name:[''],
      information: [''],
      notepadmode: [''],
      technology: [''],
      resulttype: ['']
    })
  }

  getAll() {
    this.taskListService.getAll(this.lesson_id)
    .subscribe(resp=>{
      this.tasks = resp;
    })
  }

  DefaultValue(i, task) {
    console.log(task);
    if (task.technology == 'form') {
      this.answerModule = 'form'
      this.taskListService.getTaskFields(task.id)
      .subscribe(resp=> {
        this.mySchema = this.schemaService.createSchema(resp);
        this.formFields = resp;
      })
    } else {
      this.answerModule = 'code';
      this.formFields=[];
    }
    this.query.setValue('');
    this.responseCheck = null;
    this.taskForm.get('name').setValue(task.name);
    this.taskForm.get('information').setValue(task.information);
    this.taskForm.get('resulttype').setValue(task.resulttype);
    this.taskForm.get('notepadmode').setValue(task.notepadmode);
    this.taskForm.get('technology').setValue(task.technology);
    this.currentTask = i;
    this.currentTaskId = task.id;
    this.checkAnswer = '';
  }

  

  
  changeModule() {
    if (this.answerModule=='form') {
      this.taskForm.get('resulttype').setValue('1');
      this.taskForm.get('notepadmode').setValue('');
      this.taskForm.get('technology').setValue('form');
    } else {
      this.taskForm.get('technology').setValue('sqlite');
      this.taskForm.get('notepadmode').setValue('sql');
    }
  }

  
  UpdateAnswer() {
    this.runService.updateFieldHashes(this.currentTaskId, this.schemaService.reModel(this.schemaModel))
    .subscribe(
      resp => {
      if (resp.status == 204) {
        this.checkAnswer = 'Правильные ответы успешно записаны!';
      }
    })
  }

  editTask(id, i) {
    this.taskListService.EditTask(id, this.taskForm.value)
    .subscribe(resp => {
      console.log(resp);
      this.tasks[i]=resp;
    })
  }
  deleteTask(id, i) {
    this.taskListService.DeleteTask(id)
    .subscribe();
    if (i !== -1) {
        this.tasks.splice(i, 1);
    }
  }
  addTask(id) {
    this.taskListService.AddTask(id, this.taskForm.value)
    .subscribe(resp=> {
      this.tasks.push(resp);
      this.taskForm.reset();
    });
  }
  run(id) {
    let formData = new FormData();
    this.checkAnswer = '';
    formData.append('query', this.query.value);
    this.runService.run(id, formData)
    .subscribe(resp => {
      this.responseCheck = resp;
    });
  }
  updateHash(id) {
    let formData = new FormData();
    formData.append('query', this.query.value);
    this.runService.updateCodeHashes(id, formData)
    .subscribe(resp => {
      if (resp.status == 200) {
        this.checkAnswer = 'Правильные ответы успешно записаны!';
      }
    });
  }
  getNewSchema(ev) {
    this.mySchema = null;
    this.mySchema = ev;
  }
}
